import { TipoAtendimentoProfissional } from 'graphql/types.generated'
import { MetaPath } from 'util/metaPath'
import { meta } from 'view/atendimentos/atendimento-individual/model'

import { AntecedentesFormModel } from '../antecedentes/AntecedentesForm'
import { AvaliacaoFormModel } from '../avaliacao/AvaliacaoForm'
import { FinalizacaoAtendimentoFormModel } from '../finalizacao'
import { ObjetivoFormModel } from '../objetivo'
import { PlanoFormModel } from '../plano/PlanoForm'
import { SubjetivoFormModel } from '../subjetivo/SubjetivoForm'

export type SoapFormModel =
  | AntecedentesFormModel
  | SubjetivoFormModel
  | ObjetivoFormModel
  | AvaliacaoFormModel
  | PlanoFormModel
  | FinalizacaoAtendimentoFormModel

interface SoapConfig {
  /**
   * Secoes do SOAP que nao devem aparecer
   */
  hiddenSections: MetaPath<SoapFormModel>[]
}

export const soapConfig = (
  tipoAtendProf: TipoAtendimentoProfissional,
  isObservacaoAndAuxiliarDaObservacao: boolean,
  isRetificacao?: boolean
): SoapConfig => {
  if (tipoAtendProf === TipoAtendimentoProfissional.ATENDIMENTO_PROCEDIMENTOS) {
    return isRetificacao
      ? { hiddenSections: [meta.avaliacao, meta.antecedentes] }
      : { hiddenSections: [meta.avaliacao] }
  }

  if (tipoAtendProf === TipoAtendimentoProfissional.CONSULTA) {
    return isRetificacao ? { hiddenSections: [meta.antecedentes] } : { hiddenSections: [] }
  }

  if (isObservacaoAndAuxiliarDaObservacao) {
    return { hiddenSections: [meta.avaliacao] }
  }

  return { hiddenSections: [] }
}
